<template>
  <div class="container">
    <div class="about">
      <h1 class="about__title">
        {{ about.title }}
      </h1>
      <div class="about__content">
        <div class="about__logo">
          <img
            class=""
            :src="require(`@/assets/logos/jorify_cg_white.svg`)"
            alt="Jorify logo"
          />
        </div>
        <p class="about__text">
          {{ about.text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import store from "@/store.js";

export default {
  name: "about",
  components: {},
  data() {
    return {
      about: store.about,
    };
  },
};
</script>
<style scoped>
.about {
  margin: 16px 16px 32px;
}

.about__title {
  font-family: "Saira Condensed Bold", sans-serif;
  font-weight: 700;
  font-size: 100px;
  line-height: 69px;
  color: var(--color-yellow);
  text-transform: uppercase;
}

.about__content {
  background-color: var(--color-yellow);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 5px 5px 5px;
  padding: 16px;
  max-width: 800px;
}

.about__text {
  font-family: "Titillium Regular", sans-serif;
  color: black;
  font-weight: 400;
  font-size: 18px;
  max-width: 600px;
  margin-top: 16px;
}

.about__logo {
  width: 100%;
}
</style>
